/**
 * Created by jiachenpan on 16/11/18.
 */
export function parseTime(time, cFormat, diff) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  if (diff) {
    date = new Date(date.getTime() + diff * 1000)
  }

  // 计算当前月的最后一天
  const tOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0)

  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
    t: tOfMonth.getDate()
  }

  const time_str = format.replace(/{(y|m|d|h|i|s|a|t)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function getThisMonth() {
  const time_str = []
  const d = new Date()
  const year = d.getFullYear()
  const month = d.getMonth() + 1
  const day = d.getDate()
  time_str[0] = year + '-' + (month >= 10 ? month : '0' + (month)) + '-' + '01'
  time_str[1] = year + '-' + (month >= 10 ? month : '0' + (month)) + '-' + (day >= 10 ? day : '0' + day)
  return time_str
}

export function getLastMonth() {
  const time_str = []
  const d = new Date()
  let year = d.getFullYear()
  let month = d.getMonth()
  if (month === 0) {
    month = 12
    year = year - 1
  }
  const day = new Date(year, month, 0).getDate()
  time_str[0] = year + '-' + (month >= 10 ? month : '0' + (month)) + '-' + '01'
  time_str[1] = year + '-' + (month >= 10 ? month : '0' + (month)) + '-' + day
  return time_str
}

export function getTwoMonthAgo() {
  const d = new Date()
  let month = d.getMonth()
  if (month < 2) {
    month = month + 11
  } else {
    month -= 1
  }
  return month
}

export function getTwoMonth() {
  const time_str = []
  const d = new Date()
  let year = d.getFullYear()
  let month = d.getMonth()
  if (month < 2) {
    month = month + 11
    year = year - 1
  } else {
    month -= 1
  }
  const day = new Date(year, month, 0).getDate()
  time_str[0] = year + '-' + (month >= 10 ? month : '0' + (month)) + '-' + '01'
  time_str[1] = year + '-' + (month >= 10 ? month : '0' + (month)) + '-' + day
  return time_str
}

export function getThisYear() {
  const time_str = []
  const d = new Date()
  const year = d.getFullYear()
  const month = d.getMonth() + 1
  const day = d.getDate()
  time_str[0] = year + '-' + '01' + '-' + '01'
  time_str[1] = year + '-' + (month >= 10 ? month : '0' + (month)) + '-' + (day >= 10 ? day : '0' + day)
  return time_str
}

export function getLastYear() {
  const time_str = []
  const d = new Date()
  const year = d.getFullYear()
  time_str[0] = year - 1 + '-' + '01' + '-' + '01'
  time_str[1] = year - 1 + '-' + '12' + '-' + '31'
  return time_str
}

export function computedSurplusTime(time, type) {
  if (typeof time == 'undefined' || typeof time == 'object') return
  const timeArr = time.split(' ')
  var a = new Date()
  var b = new Date(time)
  a = a.valueOf()
  b = b.valueOf()
  var c = (b - a) / 1000
  const new_Y = c / (365 * 86400)
  const new_D = c % (365 * 86400) / 86400

  // if(new_Y >= 0){
  //   var result = Math.floor(new_Y) + '年' + Math.floor(new_D) + '天';
  // } else {
  //   var result = Math.ceil(new_Y) + '年' + Math.ceil(new_D) + '天';
  // }

  if (new_Y >= 0) {
    var result = '剩余' + Math.floor(new_Y) + '年' + Math.floor(new_D) + '天'
  } else {
    if (Number(new_Y) > 0 || Number(new_D) > 0) {
      var result = '剩余' + Math.ceil(new_Y) + '年' + Math.ceil(new_D) + '天'
    } else {
      var result = '已过期'
    }
  }

  if (type == 'zh') {
    return result
  } else {
    return Math.floor(new_Y)
  }
}

// 获取N天日期
// 例如：AddDayCount=今天 0 近30天 -30
export function getDateStr(AddDayCount) {
  var dd = new Date()
  dd.setDate(dd.getDate() + AddDayCount) // 获取AddDayCount天后的日期
  var y = dd.getFullYear()
  var m = (dd.getMonth() + 1).toString().padStart(2, '0')
  var d = dd.getDate().toString().padStart(2, '0')
  return y + '-' + m + '-' + d
}
/**
 * 获取当前月份的第一天的日期字符串‘2020-01-01’
 */
/**
 * @return {string} 返回日期字符串‘2020-01-01’
 */
export function getCurMonthFirstDay() {
  const date = new Date()
  const curYear = date.getFullYear()
  let curMonth = date.getMonth() + 1
  if (curMonth < 10) {
    curMonth = '0' + curMonth
  }
  return `${curYear}-${curMonth}-01`
}
/**
 * 返回上一个月份的第一天和最后一天 的数组
 */
/**
 * @return {Array} 返回数组
 */
export function getLastMonthFLDay() {
  const date = new Date()
  let year = date.getFullYear()
  let lastMonth = date.getMonth() + 1
  let lastMonthLastDay = `${year}-${lastMonth}-01 00:00:00`
  const date2 = new Date(new Date(lastMonthLastDay) - 1)
  const y = date2.getFullYear()
  let m = date2.getMonth() + 1
  m = m < 10 ? '0' + m : m
  let d = date2.getDate()
  d = d < 10 ? '0' + d : d
  lastMonthLastDay = `${y}-${m}-${d} 23:59:59`
  lastMonth -= 1
  if (lastMonth == 0) {
    year -= 1
    lastMonth = 12
  }
  const lastMonthFirstDay = `${year}-${lastMonth}-01 00:00:00`
  return [lastMonthFirstDay, lastMonthLastDay]
}
/**
 * @函数说明: 版本号转化为数字用于比较
 * @param {*}
 */
export function v_to_num(v) {
  if (!v) {
    return 0
  }
  v = v.split('.')
  if (v.length < 3) {
    return 0
  }
  return v[0] * 10000 + v[1] * 1000 + v[2] * 100
}
